import { useEffect } from 'react';
import {
  startCallsNativeEvidencePublicationBridge,
} from '@/governor/calls/CallsNativeEvidencePublicationBridge';

let governorStartupStarted = false;

export default function GovernorStartupBridge() {
  useEffect(() => {
    if (governorStartupStarted) return;
    governorStartupStarted = true;

    startCallsNativeEvidencePublicationBridge();

    async function bootGovernorRuntime() {
      try {
        const mod = await import('@/governor/core/GovernorRuntime');
        const run =
          mod.runUnifiedGovernorRuntime ||
          mod.runGovernorRuntime;

        if (typeof run !== 'function') return;

        const runtime = await run({
          source: 'AppStartup',
          command: 'Governor OS startup bootstrap',
          timestamp: new Date().toISOString(),
        });

        const event = {
          type: 'governor.startup.boot',
          source: 'GovernorStartupBridge',
          createdAt: new Date().toISOString(),
          runtime,
        };

        const key = 'kinscircle_governor_runtime_events';
        const prior = JSON.parse(localStorage.getItem(key) || '[]');
        localStorage.setItem(key, JSON.stringify([event, ...prior].slice(0, 100)));

        window.dispatchEvent(
          new CustomEvent('kinscircle:governor-runtime-event', { detail: event })
        );
      } catch (error) {
        console.warn('Governor startup bootstrap failed', error);
      }
    }

    bootGovernorRuntime();
  }, []);

  return null;
}
